import React from "react";
import {JobOpeningInOverview} from "@/data/entities/jobOpening";
import {SetStateFn} from "@/utils/SetStateUtils";
import {Spinner, Toggle, useNotifications} from "peggirkit";
import {toggleLabel} from "peggirkit/dist/components/Input/Toggle/Single/Label/DefaultToggleLabel";
import {useIntl} from "react-intl";
import {useMutation} from "@tanstack/react-query";
import {notifyDanger, notifySuccess} from "@/utils/NotifyUtils";
import {api} from "@/data/api";

type Props = {
    jobOpening: JobOpeningInOverview,
    setTableData: SetStateFn<JobOpeningInOverview[]>,
};

const JobActivationToggle = ({jobOpening, setTableData}: Props) => {
    const intl = useIntl();
    const {notify} = useNotifications();
    const {mutate, isPending} = useMutation({
        mutationFn: (active: boolean) => api.jobOpening.updateJobOpening(jobOpening.id, {active}),
        onSuccess: (result) => {
            setTableData(prev => prev.map((j: JobOpeningInOverview) => j.id !== jobOpening.id ? j : result));
            notifySuccess(intl.formatMessage({id: "saved"}), notify)
        },
        onError: () => {
            notifyDanger(intl.formatMessage({id: "systemError"}), notify);
        },
    });

    return (
        <div className={"ml-auto w-fit flex flex-row items-center justify-start gap-1"}>
            {isPending && <Spinner size={"sm"}/>}

            <Toggle
                disabled={isPending}
                checked={jobOpening.active}
                onChange={e => mutate(e.target.checked)}
                label={toggleLabel(intl.formatMessage({id: "jobOpened"}))}
                type="checkbox"
            />
        </div>
    );
};

export default JobActivationToggle;